import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47.84,26.64c-0.18,1.65-0.54,3.28-1.06,4.86c-2.59,7.9-9.08,13.89-17.15,15.85L16.45,35.27L14,33.02
l9.84-10.93l0.22-0.26l1.11-1.22l2.11-2.35l5.93-6.59l0.35,0.36l0,0L47.84,26.64z"
  />
);

const MorpheusAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_3}
    renderShadow={renderShadow}
  >
    <>
      <path
        style={{ fill: '#A07664' }}
        d="M35.3,17.02l-0.76,14.74c-0.05,0.96-0.56,1.84-1.36,2.36l-6.53,4.24c-1.66,1.08-3.79,1.08-5.45,0l-6.53-4.24
	c-0.8-0.52-1.31-1.4-1.36-2.36l-0.75-14.74c-0.15-2.62,1.18-5.1,3.44-6.43l3.36-2c2.78-1.61,6.22-1.61,9,0l3.41,2
	C34.07,11.89,35.43,14.38,35.3,17.02z"
      />
      <path
        style={{ fill: '#A07664' }}
        d="M13,21.5c-0.26-0.76-0.76-1.43-1.41-1.9c-0.21-0.18-0.48-0.26-0.75-0.21c-0.43,0.13-0.55,0.73-0.58,1.21
	c-0.13,1-0.08,2.02,0.15,3c0.21,0.67,0.59,1.27,0.86,1.91c0.15,0.45,0.36,0.89,0.62,1.29c0.26,0.39,0.74,0.57,1.19,0.44
	c0.08-0.03,0.15-0.08,0.2-0.15c0.07-0.12,0.1-0.26,0.1-0.4l0.14-2.23c0.18-1.17,0.01-2.36-0.47-3.44"
      />
      <path
        style={{ fill: '#A07664' }}
        d="M13.21,21.44c-0.32-0.82-1.69-3.12-2.82-2.07c-0.58,0.53-0.48,1.87-0.48,2.54c0.03,1.11,0.33,2.2,0.85,3.18
	c0.35,0.75,0.59,1.84,1.37,2.29c0.42,0.3,0.99,0.23,1.33-0.15c0.16-0.38,0.22-0.8,0.18-1.21c0-0.65,0.09-1.3,0.12-1.95
	c0.12-1.08-0.05-2.18-0.49-3.18c-0.14-0.29-0.58,0-0.43,0.25c0.45,1.2,0.58,2.5,0.37,3.77c0,0.4,0.08,2.77-1.32,1.47
	c-0.23-0.37-0.41-0.76-0.52-1.18c-0.62-1.15-0.94-2.43-0.95-3.74c0-0.75-0.17-2.1,1.23-1.49c0.51,0.21,0.89,1.11,1.08,1.58
	c0.11,0.3,0.6,0.17,0.48-0.13L13.21,21.44z"
      />
      <path
        style={{ fill: '#A07664' }}
        d="M35,21.5c0.26-0.76,0.76-1.43,1.41-1.9c0.21-0.18,0.48-0.26,0.75-0.21c0.43,0.13,0.55,0.73,0.58,1.21
	c0.13,1,0.08,2.02-0.16,3c-0.25,0.65-0.53,1.29-0.85,1.91c-0.15,0.45-0.36,0.89-0.62,1.29c-0.26,0.39-0.74,0.57-1.19,0.44
	c-0.08-0.03-0.15-0.08-0.2-0.15c-0.07-0.12-0.1-0.26-0.1-0.4l-0.14-2.23c-0.2-1.16-0.06-2.36,0.41-3.44"
      />
      <path
        style={{ fill: '#A07664' }}
        d="M35.21,21.57c0.19-0.47,0.57-1.37,1.08-1.58c1.4-0.61,1.2,0.74,1.22,1.49c0,1.31-0.32,2.59-0.94,3.74
	c-0.11,0.42-0.29,0.81-0.52,1.18c-1.41,1.3-1.3-1.07-1.32-1.47c-0.21-1.27-0.08-2.57,0.37-3.77c0.14-0.29-0.29-0.54-0.43-0.25
	c-0.43,0.94-0.6,1.97-0.5,3c0,0.64,0.07,1.29,0.11,1.93c-0.04,0.47,0.02,0.94,0.18,1.38c0.29,0.35,0.79,0.46,1.2,0.26
	c0.89-0.37,1.16-1.61,1.52-2.37c0.5-0.93,0.78-1.95,0.84-3c0-0.72,0.14-2.16-0.45-2.74c-1.12-1.1-2.52,1.23-2.84,2.05
	c-0.12,0.3,0.37,0.43,0.48,0.13L35.21,21.57z"
      />
      <path
        style={{ fill: '#333333' }}
        d="M22,21.76c1.25,0.78,2.83,0.78,4.08,0c0.27-0.17,0-0.6-0.25-0.43c-1.09,0.68-2.48,0.68-3.57,0
	c-0.12-0.07-0.27-0.03-0.34,0.09C21.84,21.53,21.88,21.69,22,21.76z"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="28.59"
        cy="21.85"
        rx="3.44"
        ry="2.3"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="19.41"
        cy="21.85"
        rx="3.44"
        ry="2.3"
      />
      <path
        style={{ fill: '#54443F' }}
        d="M22.71,20.58c-0.06-0.69-0.35-1.33-0.84-1.82c-0.42-0.29-0.91-0.47-1.42-0.53L19,17.93
	c-0.65-0.19-1.34-0.22-2-0.09c-0.67,0.14-1.15,0.73-1.16,1.42c0.16-0.49,0.69-1,1.18-0.89c1.45,0.46,3.26,0.85,4.42,1.31
	c0.44,0.18,0.63,0.81,1.11,0.87L22.71,20.58z"
      />
      <path
        style={{ fill: '#54443F' }}
        d="M25.15,20.71c0.03-0.69,0.3-1.35,0.76-1.86c0.39-0.3,0.85-0.5,1.34-0.58l1.42-0.34
	c0.61-0.21,1.26-0.26,1.9-0.15c0.66,0.14,1.14,0.72,1.16,1.4c-0.17-0.49-0.67-1-1.16-0.87c-1.45,0.35-2.86,0.83-4.22,1.45
	c-0.43,0.2-0.59,0.83-1.05,0.91L25.15,20.71z"
      />
      <path
        style={{ fill: '#333333' }}
        d="M22.16,21.5c1.12,0.74,2.57,0.74,3.69,0c0.27-0.18,0-0.61-0.25-0.44c-0.96,0.66-2.23,0.66-3.19,0
	C22.13,20.89,21.88,21.33,22.16,21.5z"
      />
      <path
        style={{ fill: '#825245' }}
        d="M19.86,31.07c0.39-0.49,0.87-0.91,1.42-1.22c0.58-0.32,1.26-0.43,1.91-0.29c0.18,0.06,0.36,0.11,0.55,0.14
	c0.48-0.03,0.95-0.1,1.42-0.19c0.63,0.06,1.21,0.39,1.57,0.91c0.33,0.51,0.76,0.95,1.27,1.29c-0.59,0.01-1.18-0.09-1.74-0.3
	c-2.25-0.57-4.64,0-7,0c0.39-0.04,0.73-0.31,0.85-0.68"
      />
      <path
        style={{ fill: '#825245' }}
        d="M20,31.25c0.5-0.67,1.2-1.17,2-1.44c0.69-0.03,1.37,0.02,2.05,0.13c0.35,0,0.68-0.24,1-0.18
	c0.6,0.16,1.13,0.51,1.51,1c0.34,0.46,0.74,0.86,1.2,1.19l0.13-0.47c-1.43,0-2.79-0.56-4.26-0.54s-3,0.23-4.46,0.22l0.07,0.5
	c0.44-0.09,0.82-0.39,1-0.8c0.13-0.29-0.3-0.55-0.44-0.26l-0.7,0.57c-0.13,0.04-0.21,0.18-0.17,0.31c0.03,0.11,0.13,0.18,0.24,0.18
	c1.49,0,3-0.2,4.46-0.22s2.82,0.55,4.26,0.54c0.14,0,0.25-0.12,0.24-0.26c0-0.08-0.04-0.16-0.11-0.2c-0.83-0.55-1.22-1.57-2.12-2
	c-0.7-0.36-1.32-0.08-2.05-0.09c-0.79-0.14-1.61-0.12-2.39,0.06c-0.74,0.31-1.39,0.81-1.89,1.45c-0.21,0.24,0.14,0.59,0.35,0.35
	L20,31.25z"
      />
      <path
        style={{ fill: '#99675C' }}
        d="M20,31.87c0.18,0.45,0.58,0.77,1.05,0.84c0.48,0.08,0.96,0.11,1.44,0.1c0.73,0,1.46,0.23,2.19,0.21
	c0.71-0.01,1.4-0.22,2-0.6c0.17-0.11,0.34-0.27,0.29-0.45s-0.2-0.22-0.35-0.28c-2.15-0.79-4.51-0.83-6.69-0.1"
      />
      <path
        style={{ fill: '#99675C' }}
        d="M19.83,32.02c0.63,1.32,2.36,1,3.58,1.17c0.9,0.1,3.25,0.31,3.75-0.84s-1.5-1.21-2.09-1.32
	c-1.73-0.32-3.51-0.2-5.18,0.35c-0.31,0.09-0.18,0.58,0.13,0.48c0.93-0.3,1.89-0.47,2.86-0.51c0.85,0,2.4-0.09,3.09,0.41
	c1.34,1-1.83,1-2.34,1c-1-0.12-2.87,0.09-3.37-1c-0.14-0.29-0.57,0-0.43,0.25L19.83,32.02z"
      />
    </>
  </AvatarArtwork>
);

export default MorpheusAvatarArtwork;
